import { DEFAULT_LAYOUT } from '@/router/constant'
import type { RouteRecordRaw } from 'vue-router'

const sendMail: RouteRecordRaw = {
  path: '/send-mail',
  name: 'sendMail',
  component: DEFAULT_LAYOUT,
  redirect: '/send-mail/list',

  children: [
    {
      path: 'list',
      name: 'sendMail',
      component: () =>
        import(/** webpackChunkName "initialize" */ '@/views/sendMail/ListView.vue'),
      meta: { title: '受信一覧', requiresAuth: true },
    },
    {
      path: 'details',
      name: 'sendMailDetails',

      component: () =>
        import(/** webpackChunkName "initialize" */ '@/views/sendMail/DetailsView.vue'),

      meta: { title: '取引詳細', requiresAuth: false },
    },
    {
      path: 'remind-mail-send-list',
      name: 'RemindMailSendList',
      component: () =>
        import(
          /** webpackChunkName "initialize" */ '@/views/sendMail/RemindMailSendList/RemindMailSendList.vue'
        ),
      props: true,
      meta: { title: '未受領リマインドメールの選択', requiresAuth: true },
    },
    {
      path: 'remind-mail-send-Confirm',
      name: 'RemindMailSendConfirm',
      component: () =>
        import(
          /** webpackChunkName "initialize" */ '@/views/sendMail/RemindMailSendConfirm/RemindMailSendConfirm.vue'
        ),
      props: true,
      meta: { title: '未受領リマインドメールの確認', requiresAuth: true },
    },
    {
      path: 'direct-send-corp-list',
      name: 'DirectSendCorpList',
      component: () =>
        import(
          /** webpackChunkName "initialize" */ '@/views/sendMail/DirectSendCorpList/DirectSendCorpList.vue'
        ),
      props: true,
      meta: { title: 'ドキュメント公開企業一覧', requiresAuth: true },
    },
    {
      path: 'direct-send-file-list',
      name: 'DirectSendFileList',
      component: () =>
        import(
          /** webpackChunkName "initialize" */ '@/views/sendMail/DirectSendFileList/DirectSendFileList.vue'
        ),
      props: true,
      meta: { title: '公開ドキュメント送信選択', requiresAuth: true },
    },
    {
      path: 'direct-send-Confirm',
      name: 'DirectSendConfirm',
      component: () =>
        import(
          /** webpackChunkName "initialize" */ '@/views/sendMail/DirectSendConfirm/DirectSendConfirm.vue'
        ),
      props: true,
      meta: { title: '公開ドキュメント送信確認', requiresAuth: true },
    },
  ],
}

export default sendMail
